module.exports = "/assets/ca7d008c30233d6c2995e07b06666c70.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/S7.png
// module id = 2932
// module chunks = 0